import React from 'react';
// import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { isNullOrUndefined } from 'util';
import { isServer } from '../../tools/Utils';

export class Breakpoint extends React.Component
{
	breakpoints = {
		small: 0,
		medium: 640,
		large: 1024,
		xlarge: 1200,
		xxlarge: 1440,
	}

	render()
	{
		let {small, medium, large, up, down, only, children, ...props} = this.props;

		let minSize;
		let maxSize;

		if(!isServer)
		{
			if(up)
			{
				if(medium)
				{
					minSize=this.breakpoints.medium;
				}
				else if(large)
				{
					minSize=this.breakpoints.large;
				}
			}
			else if(down)
			{
				if(small)
				{
					maxSize=this.breakpoints.medium;
				}
				else if(medium)
				{
					maxSize=this.breakpoints.large;
				}
			}
			else if(only)
			{
				if(medium)
				{
					minSize=this.breakpoints.medium+1;
					maxSize=this.breakpoints.large;
				}

				if(small)
				{
					maxSize=this.breakpoints.medium;	
				}
				else if(large)
				{
					minSize=this.breakpoints.large+1;
				}
			}
		}

		if(isServer&&!this.props.server)
		{
			return null;
		}
		
		if(isServer||(isNullOrUndefined(minSize)&&isNullOrUndefined(maxSize)))
		{
			return (
				<React.Fragment>
					{children}
				</React.Fragment>
			);
		}

		return (
			<MediaQuery minWidth={minSize} maxWidth={maxSize} {...props} >
				{children}
			</MediaQuery>
		);
	}
}